import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { RouteComponentProps } from "react-router";
import { Dialog, DialogType, DialogFooter, DefaultButton } from "office-ui-fabric-react";
import Files from "react-files";
import styled from "styled-components";
import { uploadFiles } from "~/state/media/action";

export interface ReactFilesComponent extends React.Component<any, any>
{
    removeFiles: () => void;
}

export interface Props extends RouteComponentProps<{ parentId: string}>
{
    
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    uploadFiles: (files: File[], parentId: string) => dispatch(uploadFiles(files, parentId))
});

const UploadField = styled.div`
    .files-dropzone{
        width: 291px;
        height: 100px;
        border: 1px dashed black;
    }
    h2{
        text-align: center;
        font-size: 15px;
        margin-top: 32px;
    }`;

class Upload extends React.Component<Props & StateProps>
{
    private reactFiles: ReactFilesComponent | null = null;

    onClose = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}`);
    }

    onFilesChange = (files: File[]) =>
    {
        if (!files || files.length === 0)
        {
            return;
        }

        if (this.reactFiles !== null)
        {
            this.reactFiles.removeFiles();
        }
        const parentId = this.props.match.params.parentId;
        this.props.uploadFiles(files, parentId);
        this.props.history.push(`/media/${ parentId ? parentId : "" }`);
    }

    onFilesError = (error: any) =>
    {
        //TODO: handle errors
        alert("error code " + error.code + ": " + error.message);
    }

    private setReactFiles = (files: ReactFilesComponent) => this.reactFiles = files;

    render()
    {
        return <Dialog onDismiss={this.onClose} hidden={false} 
            dialogContentProps={{
                type: DialogType.normal,
                title: "Upload files",
            }}
            minWidth={350}
            >
            <UploadField>
                <Files
                    onChange={this.onFilesChange} 
                    onError={this.onFilesError}
                    ref={this.setReactFiles}
                    accepts={["image/png", "image/jpg", "image/jpeg", ".pdf"]}
                    minFileSize={0}
                    maxFileSize={175000000}
                    clickable
                    multiple={true}>
                    <h2>Drop files or click to upload.</h2>
                </Files>
            </UploadField>
            <DialogFooter>
                <DefaultButton onClick={this.onClose} text="Cancel" />
            </DialogFooter>
        </Dialog>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Upload);


// WEBPACK FOOTER //
// ./src/components/media/Upload.tsx